export const ROUTE_NAMES = {
  LIST: 'strategies-list',
  ETR_CREATTION: 'strategies-etr-creation',
  ETR_DETAILS: 'strategies-etr-details',
  ETP_DETAILS: 'strategies-etp-details'
}

const ROUTES = {
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'strategies'
  },
  [ROUTE_NAMES.ETR_CREATTION]: {
    name: ROUTE_NAMES.ETR_CREATTION,
    path: 'investors/strategies/etr/new'
  },
  [ROUTE_NAMES.ETR_DETAILS]: {
    name: ROUTE_NAMES.ETR_DETAILS,
    path: 'investors/strategies/etr/:id'
  },
  [ROUTE_NAMES.ETP_DETAILS]: {
    name: ROUTE_NAMES.ETP_DETAILS,
    path: 'investors/strategies/etp/:id'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.LIST].name,
    path: ROUTES[ROUTE_NAMES.LIST].path,
    component: (resolve) => require(['./views/strategies'], resolve)
  },
  {
    name: ROUTES[ROUTE_NAMES.ETR_CREATTION].name,
    path: ROUTES[ROUTE_NAMES.ETR_CREATTION].path,
    component: (resolve) => require(['./views/etr-details'], resolve),
    props: true
  },
  {
    name: ROUTES[ROUTE_NAMES.ETR_DETAILS].name,
    path: ROUTES[ROUTE_NAMES.ETR_DETAILS].path,
    component: (resolve) => require(['./views/etr-details'], resolve),
    props: true
  },
  {
    name: ROUTES[ROUTE_NAMES.ETP_DETAILS].name,
    path: ROUTES[ROUTE_NAMES.ETP_DETAILS].path,
    component: (resolve) => require(['./views/etp-details'], resolve),
    props: true
  }
]
